import { render } from "./TypingSpeedTest.vue?vue&type=template&id=2a948d41&scoped=true&lang=html"
import script from "./TypingSpeedTest.vue?vue&type=script&lang=js"
export * from "./TypingSpeedTest.vue?vue&type=script&lang=js"

import "./TypingSpeedTest.vue?vue&type=style&index=0&id=2a948d41&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a948d41"]])

export default __exports__